import React, {PropsWithChildren} from 'react';
import {StackNavigationOptions} from '@react-navigation/stack/src/types';
import AppLogin from '../views/login/login';
import AppRegister from '../views/login/AppRegister';
import ChatGPTAssist from '../views/chatGPTAssist/ChatGPTAssist';
import xkwRoutes from './xkwRoutes';
import UserCenter from '../views/userCenter';
import SettingList from '../views/userCenter/setting/SettingList';
import FloatAIBao from '../layout/FloatAIBao';
import {WebLayout, WebLayoutWithBack} from '../layout/WebLayout';
import ForgotPassword from '../views/login/forgotPassword';
import AboutOnePad, {
  FuWuHtmlDocumentRender,
  YinSiHtmlDocumentRender,
} from '../views/userCenter/about';
import ChatGPTTeacher from '../views/chatGPTTeacher/ChatGPTTeacher';
import CDK from '../views/userCenter/CDK/CDK';
import ChatRecordInfo from '../views/userCenter/record/ChatRecordInfo';
import RecordIndex from '../views/userCenter/record/recordIndex';

export interface routeObject {
  name: string;
  component: (props: any) => React.JSX.Element;
  layout?:
    | React.ComponentType<PropsWithChildren<any>>
    | React.FC<PropsWithChildren<any>>;
  options?: StackNavigationOptions;
}

const routes: Array<routeObject> = [
  //AI助教界面
  {
    name: 'ChatGPTAssist',
    component: ChatGPTAssist,
    options: {
      header: () => null,
    },
  },
  // AI伴学师
  {
    name: 'ChatGPTTeacher',
    component: ChatGPTTeacher,
    layout: FloatAIBao,
    options: {
      header: () => null,
    },
  },
  {
    name: 'Login',
    component: AppLogin,
    layout: WebLayout,
    options: {
      header: () => null,
    },
  },
  // 注册页面
  {
    name: 'Register',
    component: AppRegister,
    layout: WebLayoutWithBack,
    options: {
      title: '注册账号',
    },
  },
  // 忘记密码
  {
    name: 'ForgetPassword',
    component: ForgotPassword,
    options: {
      title: '重置密码',
    },
  },
  ...xkwRoutes,
  {
    name: 'UserCenter',
    component: UserCenter,
    layout: FloatAIBao,
    options: {
      title: '个人中心',
    },
  },
  {
    name: 'SettingList',
    component: SettingList,
    layout: FloatAIBao,
    options: {
      title: '设置',
    },
  },
  {
    name: 'YinSiDocument',
    component: YinSiHtmlDocumentRender,
    layout: FloatAIBao,
    options: {
      title: '隐私政策',
    },
  },
  {
    name: 'FuWuDocument',
    component: FuWuHtmlDocumentRender,
    layout: FloatAIBao,
    options: {
      title: '服务协议',
    },
  },
  {
    name: 'AboutOnePad',
    component: AboutOnePad,
    layout: FloatAIBao,
    options: {
      title: '关于我们',
    },
  },
  {
    name: 'RecordIndex',
    component: RecordIndex,
    layout: FloatAIBao,
    options: {
      title: '作业记录',
    },
  },
  {
    name: 'ChatRecordInfo',
    component: ChatRecordInfo,
    layout: FloatAIBao,
    options: {
      title: '聊天记录',
    },
  },
  {
    name: 'UseCDK',
    component: CDK,
    layout: WebLayout,
    options: {
      title: '兑换权益',
    },
  },
];

export default routes;
